import { render } from "./DokoDownload.vue?vue&type=template&id=4ab2845c"
import script from "./DokoDownload.vue?vue&type=script&lang=js"
export * from "./DokoDownload.vue?vue&type=script&lang=js"

import "./DokoDownload.vue?vue&type=style&index=0&id=4ab2845c&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__